import { z } from "zod";

export const syncReceivedBooksSchema = () => {
  return z.object({
    agreement_id: z
      .number()
      .nullable()
      .refine((value) => value !== null, "Selecione um convênio."),
    months: z.array(z.number()).min(1, "Selecione ao menos um mês."),
    years: z.array(z.number()).min(1, "Selecione ao menos um ano."),
    product_id: z.number().optional().nullable(),
    cpfs: z.string().optional().nullable(),
  });
};

export type SyncReceivedBooksFormValues = z.infer<ReturnType<typeof syncReceivedBooksSchema>>;
